import { render } from "./TemplateB.vue?vue&type=template&id=1cb17c5b"
import script from "./TemplateB.vue?vue&type=script&lang=js"
export * from "./TemplateB.vue?vue&type=script&lang=js"

import "./TemplateB.vue?vue&type=style&index=0&id=1cb17c5b&lang=css"
script.render = render

export default script